import React from "react";
import GameRoomBackButton from "../GameRoomBackButton";
import FlippyBird from "./FlippyBird";
import "./FlippyBirdPage.css";

export default function FlippyBirdPage() {
  return (
    <main className="flippy-bird-page">
      <div className="flippy-bird-page__inner">
        <GameRoomBackButton standalone />
        <FlippyBird />
      </div>
    </main>
  );
}
